const ArticleEdition = () => {
	return <h1>Tu jest edycja</h1>;
};

export { ArticleEdition };
